import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, Thumbs, Scrollbar, EffectFade } from 'swiper/modules';
/**
 * @param swiperInit
 */
export default function swiperInit() {
	const homeBannerSwiper = new Swiper(".banner-slider .swiper", {
		modules: [Autoplay, Navigation, Pagination, EffectFade],
		loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		effect: "fade",
		speed: 1000,
		navigation: {
			nextEl: ".banner-slider .button-next",
			prevEl: ".banner-slider .button-prev",
		},
		pagination: {
			el: ".banner-slider .swiper-pagination",
			clickable: true,
		},
	});
	const productSwiperThumbs = new Swiper(".product-dt-slider .product-thumbs .swiper", {
		spaceBetween: 10,
		slidesPerView: 3,
		// freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			768: {
				slidesPerView: 4,
			},
			1200: {
				spaceBetween: 24,
				slidesPerView: 5,
			},
		},
	});
	const productSwiperTop = new Swiper(".product-dt-slider .product-top .swiper", {
		modules: [Navigation, Thumbs],
		spaceBetween: 10,
		navigation: {
			nextEl: ".product-dt-slider .button-next",
			prevEl: ".product-dt-slider .button-prev",
		},
		thumbs: {
			swiper: productSwiperThumbs,
		},
	});
	$('.one-slider').each(function (index) {
		$(this).find('.swiper').addClass(`swiper-one-${index}`);
		$(this).find('.swiper-pagination').addClass(`pagination-one-${index}`);
		$(this).find('.button-prev').addClass(`prev-one-${index}`);
		$(this).find('.button-next').addClass(`next-one-${index}`);
		const oneSlider = new Swiper(`.swiper-one-${index}`, {
			modules: [Autoplay, Navigation, Pagination],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			// rewind: true,
			speed: 1000,
			spaceBetween: 16,
			slidesPerView: 1,
			navigation: {
				prevEl: `.one-slider .prev-one-${index}`,
				nextEl: `.one-slider .next-one-${index}`,
			},
			pagination: {
				el: `.one-slider .pagination-one-${index}`,
				clickable: true,
				// dynamicBullets: true,
			},
			breakpoints: {
				768: {
					spaceBetween: 32,
				},
				1400: {
					spaceBetween: 40,
				},
			},
		});
	});
	$('.two-slider').each(function (index) {
		$(this).find('.swiper').addClass(`swiper-two-${index}`);
		$(this).find('.swiper-pagination').addClass(`pagination-two-${index}`);
		$(this).find('.button-prev').addClass(`prev-two-${index}`);
		$(this).find('.button-next').addClass(`next-two-${index}`);
		const twoSlider = new Swiper(`.swiper-two-${index}`, {
			modules: [Autoplay, Navigation, Pagination],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			// rewind: true,
			speed: 1000,
			spaceBetween: 16,
			slidesPerView: 1,
			navigation: {
				prevEl: `.two-slider .prev-two-${index}`,
				nextEl: `.two-slider .next-two-${index}`,
			},
			pagination: {
				el: `.two-slider .pagination-two-${index}`,
				clickable: true,
				dynamicBullets: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				1200: {
					slidesPerView: 2,
					spaceBetween: 32,
				},
				1400: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
			},
		});
	});
	$('.three-slider').each(function (index) {
		$(this).find('.swiper').addClass(`swiper-three-${index}`);
		$(this).find('.swiper-pagination').addClass(`pagination-three-${index}`);
		$(this).find('.button-prev').addClass(`prev-three-${index}`);
		$(this).find('.button-next').addClass(`next-three-${index}`);
		const threeSlider = new Swiper(`.swiper-three-${index}`, {
			modules: [Autoplay, Navigation, Pagination],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			// rewind: true,
			speed: 1000,
			spaceBetween: 16,
			slidesPerView: 1,
			navigation: {
				prevEl: `.three-slider .prev-three-${index}`,
				nextEl: `.three-slider .next-three-${index}`,
			},
			pagination: {
				el: `.three-slider .pagination-three-${index}`,
				clickable: true,
				dynamicBullets: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
				1400: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
			},
		});
	});
	$('.four-slider').each(function (index) {
		$(this).find('.swiper').addClass(`swiper-four-${index}`);
		$(this).find('.swiper-pagination').addClass(`pagination-four-${index}`);
		$(this).find('.swiper-scrollbar').addClass(`scrollbar-four-${index}`);
		$(this).find('.button-prev').addClass(`prev-four-${index}`);
		$(this).find('.button-next').addClass(`next-four-${index}`);
		const fourSlider = new Swiper(`.swiper-four-${index}`, {
			modules: [Navigation, Pagination, Scrollbar],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			// rewind: true,
			speed: 1000,
			spaceBetween: 16,
			slidesPerView: 1,
			navigation: {
				prevEl: `.four-slider .prev-four-${index}`,
				nextEl: `.four-slider .next-four-${index}`,
			},
			pagination: {
				el: `.four-slider .pagination-four-${index}`,
				clickable: true,
				dynamicBullets: true,
			},
			scrollbar: {
				el: `.four-slider .scrollbar-four-${index}`,
				draggable: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 32,
				},
				1400: {
					slidesPerView: 4,
					spaceBetween: 40,
				},
			},
		});
	});
	$('.brand-slider').each(function (index) {
		$(this).find('.swiper').addClass(`swiper-brand-${index}`);
		$(this).find('.swiper-pagination').addClass(`pagination-brand-${index}`);
		$(this).find('.button-prev').addClass(`prev-brand-${index}`);
		$(this).find('.button-next').addClass(`next-brand-${index}`);
		const brandSlider = new Swiper(`.swiper-brand-${index}`, {
			modules: [Autoplay, Navigation, Pagination],
			loop: true,
			autoplay: {
				delay: 1,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			speed: 3000,
			spaceBetween: 16,
			slidesPerView: 'auto',
			navigation: {
				prevEl: `.brand-slider .prev-brand-${index}`,
				nextEl: `.brand-slider .next-brand-${index}`,
			},
			pagination: {
				el: `.brand-slider .pagination-brand-${index}`,
				clickable: true,
			},
			breakpoints: {
				1200: {
					spaceBetween: 32,
				},
				1400: {
					spaceBetween: 40,
				},
			},
		});
	});
	const home4Slider = new Swiper(".home-4-slider .swiper", {
		modules: [Autoplay, Navigation, Scrollbar],
		// loop: true,
		// autoplay: {
		// 	delay: 5000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		speed: 1000,
		spaceBetween: 16,
		slidesPerView: 'auto',
		// centeredSlides: true,
		navigation: {
			prevEl: ".home-4-slider .button-prev",
			nextEl: ".home-4-slider .button-next",
		},
		scrollbar: {
			el: ".home-4-slider .swiper-scrollbar",
			// draggable: true,
		},
		breakpoints: {
			1200: {
				spaceBetween: 20,
			},
		},
	});
	const home7Slider = new Swiper(".home-7-slider .swiper", {
		modules: [Autoplay, Navigation, Scrollbar],
		// loop: true,
		// autoplay: {
		// 	delay: 5000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		speed: 1000,
		spaceBetween: 16,
		slidesPerView: 'auto',
		// centeredSlides: true,
		navigation: {
			prevEl: ".home-7-slider .button-prev",
			nextEl: ".home-7-slider .button-next",
		},
		scrollbar: {
			el: ".home-7-slider .swiper-scrollbar",
			// draggable: true,
		},
		breakpoints: {
			1200: {
				spaceBetween: 20,
			},
		},
	});
	$('.mega-product-slider').each(function (index) {
		const Slider = $(this).find('.swiper')[0];
		const ButtonPrev = $(this).find('.button-prev')[0];
		const ButtonNext = $(this).find('.button-next')[0];
		const threeSlider = new Swiper(Slider, {
			modules: [Navigation],
			// loop: true,
			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// 	pauseOnMouseEnter: true,
			// },
			// rewind: true,
			speed: 1000,
			spaceBetween: 16,
			slidesPerView: 1,
			navigation: {
				prevEl: ButtonPrev,
				nextEl: ButtonNext,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 16,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
			},
		});
	});
	$('.product-category-slider').each(function (index) {
		const Slider = $(this).find('.swiper')[0];
		const ButtonPrev = $(this).find('.button-prev')[0];
		const ButtonNext = $(this).find('.button-next')[0];
		const pagination = $(this).find('.swiper-pagination')[0];
		const threeSlider = new Swiper(Slider, {
			modules: [Navigation, Pagination],
			// loop: true,
			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// 	pauseOnMouseEnter: true,
			// },
			// rewind: true,
			speed: 1000,
			spaceBetween: 16,
			slidesPerView: 1.5,
			navigation: {
				prevEl: ButtonPrev,
				nextEl: ButtonNext,
			},
			pagination: {
				element: pagination,
				clickable: true,
			},
			breakpoints: {
				768: {
					spaceBetween: 24,
					slidesPerView: 2,
				},
			},
		});
	});
	$('.product-4-slider').each(function (index) {
		const Slider = $(this).find('.swiper')[0];
		const ButtonPrev = $(this).find('.button-prev')[0];
		const ButtonNext = $(this).find('.button-next')[0];
		const pagination = $(this).find('.swiper-pagination')[0];
		const threeSlider = new Swiper(Slider, {
			modules: [Navigation, Pagination],
			// loop: true,
			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// 	pauseOnMouseEnter: true,
			// },
			// rewind: true,
			speed: 1000,
			spaceBetween: 3,
			slidesPerView: 'auto',
			navigation: {
				prevEl: ButtonPrev,
				nextEl: ButtonNext,
			},
			pagination: {
				element: pagination,
				clickable: true,
			},
		});
	});
	$('.product-ex-2-slider').each(function (index) {
		const Slider = $(this).find('.swiper')[0];
		const ButtonPrev = $(this).find('.button-prev')[0];
		const ButtonNext = $(this).find('.button-next')[0];
		const pagination = $(this).find('.swiper-pagination')[0];
		const threeSlider = new Swiper(Slider, {
			modules: [Navigation, Pagination],
			// loop: true,
			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// 	pauseOnMouseEnter: true,
			// },
			// rewind: true,
			speed: 1000,
			spaceBetween: 16,
			slidesPerView: 'auto',
			navigation: {
				prevEl: ButtonPrev,
				nextEl: ButtonNext,
			},
			pagination: {
				el: pagination,
				clickable: true,
			},
		});
	});
	$('.pro-dt-3-slider').each(function (index) {
		const slider = $(this).find('.swiper')[0];
		const buttonPrev = $(this).find('.button-prev')[0];
		const buttonNext = $(this).find('.button-next')[0];
		const pagination = $(this).find('.swiper-pagination')[0];
		const proDt3Slider = new Swiper(slider, {
			modules: [Autoplay, Navigation, Pagination],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			// initialSlide: 1,
			// rewind: true,
			speed: 1000,
			spaceBetween: 16,
			slidesPerView: 1,
			navigation: {
				prevEl: buttonPrev,
				nextEl: buttonNext,
			},
			pagination: {
				el: pagination,
				clickable: true,
				// dynamicBullets: true,
			},
			breakpoints: {
				768: {
					spaceBetween: 32,
				},
				1200: {
					slidesPerView: 3,
					centeredSlides: true,
					spaceBetween: 32,
				},
				1400: {
					slidesPerView: 3,
					centeredSlides: true,
					spaceBetween: 68,
				},
			},
		});
	});
	$('.pro-dt-4-slider').each(function (index) {
		const slider = $(this).find('.swiper')[0];
		const buttonPrev = $(this).find('.button-prev')[0];
		const buttonNext = $(this).find('.button-next')[0];
		const pagination = $(this).find('.swiper-pagination')[0];
		const proDt4Slider = new Swiper(slider, {
			modules: [Navigation, Pagination],
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			// rewind: true,
			speed: 1000,
			spaceBetween: 0,
			slidesPerView: 1,
			navigation: {
				prevEl: buttonPrev,
				nextEl: buttonNext,
			},
			pagination: {
				el: pagination,
				clickable: true,
				dynamicBullets: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
				},
			},
		});
	});
}

